<template>
    <div class="container px-2 px-lg-4 pt-4" v-if="globalStore.hasPermissionTo('home')">
        <div class="row">
            <div v-if="useAccountStore().account.status.slug == 'pending'" class="col-12 mb-4">
                <div class="box_content p-4" id="account_pending">
                    <div class="d-flex">
                        <font-awesome-icon id="icon" class="mb-4 me-3" icon="fa-solid fa-clock" />
                        <div>
                            <h5>Estamos preparando tudo para você</h5>
                            <p class="mb-0">Seus documentos estão em processo de análise por nossa equipe de segurança.
                                Este processo pode levar até 72 horas.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 mb-4">
                <div class="box_content p-0">
                    <div class="p-2 px-3 header_sales">
                        <div class="row">
                            <div class="col p-3 px-4 box_amount">
                                <h6 class="mb-1">Hoje</h6>
                                <h5 class="mb-0" v-if="homeStoreLoaded == 'true'">{{ globalStore.formatMoney(homeStore.home_infos.informations.today)}} <span :class="homeStore.home_infos.informations.percent_today > 0 ? 'up' : homeStore.home_infos.informations.percent_today < 0 ? 'down' : ''" ><font-awesome-icon :icon="'fa-regular ' + [homeStore.home_infos.informations.percent_today > 0 ? 'fa-arrow-up-right' : [homeStore.home_infos.informations.percent_today < 0 ? 'fa-arrow-down-right' : 'fa-arrow-right']]" class="mx-1" /> {{ parseFloat(homeStore.home_infos.informations.percent_today).toFixed(2) }}%</span></h5>
                                <h5 class="mb-0" v-else>R$ 0,00 <span><font-awesome-icon icon="fa-regular fa-arrow-right" class="mx-1" /> 0%</span></h5>
                            </div>

                            <div class="col p-3 px-4 box_amount">
                                <h6 class="mb-1">Ontem</h6>
                                <h5 v-if="homeStoreLoaded == 'true'" class="mb-0">{{ globalStore.formatMoney(homeStore.home_infos.informations.yesterday) }}</h5>
                                <h5 v-else class="mb-0">R$ 0,00</h5>
                            </div>

                            <div class="col p-3 px-4 box_amount">
                                <h6 class="mb-1">Este mês</h6>
                                <h5 v-if="homeStoreLoaded == 'true'" class="mb-0">{{ globalStore.formatMoney(homeStore.home_infos.informations.month) }}<span :class="homeStore.home_infos.informations.percent_month > 0 ? 'up' : homeStore.home_infos.informations.percent_month < 0 ? 'down' : ''"><font-awesome-icon :icon="'fa-regular ' + [homeStore.home_infos.informations.percent_month > 0 ? 'fa-arrow-up-right' : [homeStore.home_infos.informations.percent_month < 0 ? 'fa-arrow-down-right' : 'fa-arrow-right']]" class="mx-1" /> {{ parseFloat(homeStore.home_infos.informations.percent_month).toFixed(2) }}%</span></h5>
                                <h5 v-else class="mb-0">R$ 0,00<span><font-awesome-icon icon="fa-regular fa-arrow-right" class="mx-1" /> 0%</span></h5>
                            </div>

                            <div class="col p-3 px-4 box_amount">
                                <h6 class="mb-1">Mês passado</h6>
                                <h5 v-if="homeStoreLoaded == 'true'" class="mb-0">{{ globalStore.formatMoney(homeStore.home_infos.informations.last_month) }}</h5>
                                <h5 v-else class="mb-0">R$ 0,00</h5>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-12 mb-4">
                <div class="box_content p-0">
                    <div>
                        <LineChart v-if="homeStoreLoaded == 'true'" :chart="homeStore.home_chart"
                            :chart_params="chartparams" ref="childMethodLine" :chartStoreLoaded="homeStoreLoaded" />
                        <LineChart v-else ref="childMethodLine" />
                    </div>
                </div>
            </div>

            <div class="col-12 mb-4">
                <div class="box_content">
                    <div class="p-4 pb-0">
                        <BaseMetricsBox class="mb-2">
                            <div class="metrics_header">
                                <div class="title item flex-grow-1">
                                    <h2 class="metrics_title">
                                        <font-awesome-icon icon="fas fa-chart-simple" />
                                        <span>Métricas </span>
                                    </h2>
                                </div>
                                <div id="DayPicker" class="datepicker metrics_amount_picker preset_picker mt-lg-0 mt-4">
                                    <BaseDatePicker 
                                        @updateInfos="updateMetricsInfo()"
                                        @clearDayPicker="clearInsightinfos()"
                                        ref="childMethodClear"
                                        placeholder="Hoje"
                                        :hideInputIcon="false"
                                        style="margin-top: 0px !important"
                                        range
                                        multi
                                        v-model="params.date_range"
                                        :storeLoaded="metricsInfoLoaded"
                                        :loadedDayPicker="true"
                                        enablePreset
                                    />
                                </div>
                            </div>
                        </BaseMetricsBox>
                    </div>
                    <div class="row box_spacing_metrics p-4">
                        <div class="col">
                            <BaseInfoGroup svg_icon="fas fa-browser" title="Sessões"
                                :info_value="homeStore.home_infos.metric.sessions === null ? '0' : homeStore.home_infos.metric.sessions" />
                        </div>
                        <div class="col">
                            <BaseInfoGroup svg_icon="fas fa-sync" title="Conversão"
                                :info_value="homeStore.home_infos.metric.percent_conversion === null ? '0%' : homeStore.home_infos.metric.percent_conversion" />
                        </div>
                        <div class="col">
                            <BaseInfoGroup svg_icon="fas fa-running" title="Abandonado"
                                :info_value="homeStore.home_infos.metric.abandoned_carts === null ? 'R$ 0,00' : globalStore.formatMoney(homeStore.home_infos.metric.abandoned_carts)" />
                        </div>
                        <div class="col">
                            <BaseInfoGroup svg_icon="fas fa-calculator" title="Ticket Médio"
                                :info_value="homeStore.home_infos.metric.average_ticket === null ? 'R$ 0,00' : globalStore.formatMoney(homeStore.home_infos.metric.average_ticket)" />
                        </div>
                    </div>

                    <BarChart ref="childMethodBar" :chartStoreLoaded="metricsInfoLoaded" />
                </div>
            </div>
        </div>
    </div>
    <div class="container px-2 px-lg-4 pt-4" v-else>
        <h3>Olá, {{ auth.name }}</h3>
    </div>
</template>

<script setup>
import LineChart from '@/components/includes/home/LineChart.vue'
import BarChart from '@/components/includes/home/BarChart.vue'
import { ref, onBeforeMount, onMounted, onBeforeUnmount, watch } from "vue";
import { useRouter, useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useGlobalStore } from '@/stores/global';
import { useHomeStore } from '@/stores/home';
import { useAccountStore } from '@/stores/account';

const router = useRouter();
const route = useRoute();

const globalStore = useGlobalStore();
const { defaultStore } = storeToRefs(globalStore);

const homeStore = useHomeStore();

import { useAuthStore } from "@/stores/auth";
const auth = useAuthStore();

const params = ref({
    date_range: null,
    home_informations: null,
});

const chartparams = ref({
    chart_this_month: null,
    chart_last_month: null,
})

const infoparams = ref({
    date_start: null,
    date_end: null,
})

const today = new Date();

const childMethodBar = ref(null);
const childMethodLine = ref(null);
const childMethodClear = ref(null);
const homeStoreLoaded = ref(null);
const metricsInfoLoaded = ref(false);
const todayDate = ref(null)
var initialFilters = null;

onBeforeMount(async () => {
    globalStore.cleanObject(homeStore.home_infos);
    homeStore.home_infos.metric = {
        sessions: null,
        percent_conversion: null,
        average_ticket: null,
        abandoned_carts: null,
    }

    if (!globalStore.hasPermissionTo('home')) {
        return;
    }

    if(route.query){
        params.value = route.query
    }

    if(route.query.date_start && route.query.date_end){
        params.value.date_range = route.query.date_start + '@' + route.query.date_end
    }

    if (infoparams.value.date_start && infoparams.value.date_end) {
        params.value.date_range = infoparams.value.date_start + '@' + infoparams.value.date_end
    }

    if (!infoparams.value.date_start && !infoparams.value.date_end) {
        setTodayDate()
    }

    setTimeout(() => {
        globalStore.loader('show');
        homeStore.tryHomeChart();
        homeStore.tryHomeInfos(infoparams.value).then(() => {
            homeStoreLoaded.value = 'true';
            metricsInfoLoaded.value = true;
            globalStore.loader('hide');
        });
    })
});

onMounted(() => {
    if(!params.value.date_range){
        homeStore.tryHomeInfos(infoparams.value).then(() =>{
            globalStore.loader('hide')
            metricsInfoLoaded.value = true;
        })
    } else{
        metricsInfoLoaded.value = true;
        updateMetricsInfo();
    }

    if (initialFilters) {
        childMethodClear.value.resizeDayPicker();
        initialFilters.date_range = null
    }
})

onBeforeUnmount(() => {
    clearInterval(intervalGets)
})

function clearInsightinfos(){
    globalStore.loader('show')
    params.value.date_range = null;
    setTodayDate();

    document.querySelector('.metrics_amount_picker').setAttribute("style","width:120px;");

    homeStore.tryHomeInfos(infoparams.value).then(() => {
        globalStore.loader('hide');
    })

    var inputDayPicker = document.querySelector(".metrics_amount_picker .dp__input_wrap");
    inputDayPicker.style.width = 100 + '%';
    router.replace('');
}

function setTodayDate() {
    let getFullYear = today.getFullYear();
    let getMonth = today.getMonth() + 1;
    let getDate = today.getDate();

    if (getDate <= 9) {
        infoparams.value.date_start = getFullYear + '-' + getMonth + '-0' + getDate
        infoparams.value.date_end = getFullYear + '-' + getMonth + '-0' + getDate
        todayDate.value = getFullYear + '-' + getMonth + '-0' + getDate
        if (getMonth <= 9) {
            infoparams.value.date_start = getFullYear + '-0' + getMonth + '-0' + getDate
            infoparams.value.date_end = getFullYear + '-0' + getMonth + '-0' + getDate
            todayDate.value = getFullYear + '-0' + getMonth + '-0' + getDate
        }
    }

    if (getMonth <= 9) {
        infoparams.value.date_start = getFullYear + '-0' + getMonth + '-' + getDate
        infoparams.value.date_end = getFullYear + '-0' + getMonth + '-' + getDate
        todayDate.value = getFullYear + '-0' + getMonth + '-' + getDate
        if (getDate <= 9) {
            infoparams.value.date_start = getFullYear + '-0' + getMonth + '-0' + getDate
            infoparams.value.date_end = getFullYear + '-0' + getMonth + '-0' + getDate
        }
    }
}

async function loadChartHome() {
    let usedParams = {};
    globalStore.loader('show');
    Object.keys(chartparams.value).forEach((key) => {
        if (chartparams.value[key] != null && chartparams.value[key] != '') {

            let currentParams = {
                ...usedParams,
                [key]: chartparams.value[key]
            };
            usedParams = currentParams;
        }
    });
    router.replace({ query: usedParams });
    await homeStore.tryHomeChart(chartparams.value);
    childMethodLine.value.updateChart();
    childMethodBar.value.updateChart();
    globalStore.loader('hide');
}

function updateMetricsInfo() {
    if(params.value.date_range){
        globalStore.loader('show')
        if(typeof params.value.date_range === 'string'){
            infoparams.value.date_start = params.value.date_range.split('@')[0];
            infoparams.value.date_end = params.value.date_range.split('@')[1];
        }else{
            infoparams.value.date_start = params.value.date_range[0]
            infoparams.value.date_end = params.value.date_range[1]
        }
        let getInput = document.querySelector('.metrics_amount_picker');
        getInput.setAttribute("style","width:fit-content;");

        childMethodClear.value.resizeDayPicker();

        router.replace({query: infoparams.value})
        homeStore.tryHomeInfos(infoparams.value).then(() =>{
            globalStore.loader('hide')
        })
    }
}

if (globalStore.hasPermissionTo('home')) {
    var intervalGets = setInterval(function () {
        if (!document.hidden && route.name == 'home') {
            homeStore.tryHomeInfos(infoparams.value);
            childMethodLine.value.updateChart();
            childMethodBar.value.updateChart();
        }
    }, 10000);
}

let loadDefaultStore = false;
watch(defaultStore, function () {
    if (!loadDefaultStore) {
        loadDefaultStore = true;
        globalStore.loader('show');
        childMethodLine.value.updateChart();
        childMethodBar.value.updateChart();
        homeStore.tryHomeInfos(infoparams.value);
        loadChartHome().then(() => {
            globalStore.loader('hide');
            loadDefaultStore = false;
            
        });
    }
});

</script>

<style scoped>
.box_content {
    margin-bottom: 0px;
}

:deep(.title h2) {
    font-weight: 500;
    color: #808080;
}

.header_actions {
    float: right;
    margin-top: -26px;
    background: transparent;
    white-space: nowrap;
}

#DayPicker>.form-group {
    width: fit-content;
}

.box_spacing_metrics {
    display: flex;
    justify-content: space-between;
}

.metrics_header{
    display: flex;
    align-items: center;
    max-width: 1350px;
    margin: 0 auto;
}

.metrics_amount_picker:deep(input::placeholder) {
    font-family: Poppins;
    font-size: 14px;
    padding-left: 5px;
    position: absolute;
    margin-top: 1px;
    font-weight: 500;
}

#DayPicker :deep(#size-calibration){
    position: absolute;
}

#DayPicker :deep(.dp__input){
    border-radius: 10px;
}

.metrics_amount_picker:deep(input::placeholder) {
    font-family: Poppins;
    font-size: 14px;
    padding-left: 0px;
    position: absolute;
    margin-top: 1px;
    font-weight: 500;
}


.metrics_amount_picker :deep(.dp__input_wrap) {
    width: 85px;
}

.amount_total {
    font-weight: 600;
}

.amount_available {
    font-weight: 600;
    font-size: 18px;
    white-space: nowrap;
    margin-bottom: 3px;
}

.balance_weak_text {
    font-weight: 500;
    font-size: 14px;
    color: #808080;
    margin-bottom: 0px !important;
}

.circle {
    margin-top: 5px;
    margin-right: 10px;
    width: 10px !important;
    height: 10px !important;
    border-radius: 10px !important;
}

.metrics_title {
    display: inline-block;
    font-size: 18px;
    margin: 0;

    font-weight: 600;
}

.metrics_title svg {
    margin-right: 9.5px;
    color: #28bc6d;
    width: 23px;
    height: 18px !important;
}

:deep(.info_value) {
    font-weight: 500 !important;
}

.sales_datepicker {
    display: flex;
    margin-right: 20px;
}

.sales_datepicker :deep(.circle) {
    position: relative;
    top: 36px;
    right: -30px;
    z-index: 9;
}

#FirstSalesDatepicker,
#SecondSalesDatepicker {
    width: min-content;
    margin-top: 0px !important;
    margin-bottom: 16px;
}

.sales_datepicker :deep(.dp__input_wrap) {
    padding: 6px 0px 6px 20px;
}

.sales_datepicker:deep(input) {
    border-radius: 10px;
    width: 100%;
    border: 1px solid #d7d7d7;
    padding-left: 30px;
}

#account_pending {
    background-color: #f6c430;
    border: 0;
}

#account_pending svg {
    font-size: 20px;
}

#payment_chart {
    position: relative;
    top: 5px;
    height: 100px;
}

#payment_chart #percentage_icons .item {
    display: flex;
    margin-top: 5px;
    margin-bottom: 5px;
    white-space: nowrap;
}

#payment_chart #percentage_icons p {
    margin-bottom: 0px
}

#payment_chart #pie_chart:before {
    content: "";
    width: 80px;
    height: 80px;
    display: block;
    position: absolute;
    top: 9px;
    left: 21px;
    border-radius: 50px;
    box-shadow: inset 0px 0px 0px 13px #e2e2e2;
}

.box_amount h6 {
    opacity: 0.7;
    font-weight: 500;
    font-size: 14px;
}

.box_amount h5 {
    font-size: 18px;
}

.box_amount span {
    font-size: 15px;
    opacity: 0.7;
}

.box_amount .up {
    color: #28bc6d ;
    opacity: 0.9;
}


.box_amount .down {
    color: #db2222;
    opacity: 0.9;
}

@media screen and (max-width: 992px) {
    .box_spacing_metrics {
        --bs-gutter-x: 1.5rem;
        --bs-gutter-y: 0;
        display: flex;
        flex-wrap: wrap;
        margin-top: calc(-1 * var(--bs-gutter-y));
        margin-right: calc(-0.5 * var(--bs-gutter-x));
        margin-left: calc(-0.5 * var(--bs-gutter-x));
    }

    .title h2 {
        width: 100%;
        text-align: center;
    }

    .metrics_header{
        display: block;
    }

    #DayPicker>.form-group {
        width: auto;
    }

    .item_metrics {
        margin-top: 10px;
        margin-bottom: 10px;
        width: 100%;
    }

    .metrics_amount_picker,
    .metrics_amount_picker :deep(.dp__input_wrap),
    .metrics_amount_picker :deep(.dp__input) {
        width: 100% !important;
        text-align: center;
    }

    .metrics_amount_picker:deep(input::placeholder) {
        padding-left: 10px;
        position: absolute;
        margin-top: 1px;
        font-weight: 500;
    }

    .metrics_amount_picker :deep(.dp__input_icon) {
        left: 90% !important;
    }

    .header_actions {
        width: 100%;
        margin-top: 15px;
    }
    
    .sales_datepicker {
        margin-top: -10px;
        margin-bottom: 15px;
    }

    .sales_datepicker :deep(.dp__main > div:first-child) {
        width: fit-content;
    }

    .sales_datepicker :deep(.dp__input) {
        width: 100%;
    }

    #DayPicker :deep(#size-calibration) {
        position: static;
    }

}

#DayPicker :deep(#size-calibration){
    position: absolute;
}

@media screen and (max-width: 375px) {
    .sales_datepicker {
        display: block;
    }

    #FirstSalesDatepicker,
    #SecondSalesDatepicker {
        margin-left: auto !important;
        margin-right: auto !important;
        margin-bottom: 0px;
    }

    .metrics_amount_picker,
    .metrics_amount_picker :deep(.dp__input_wrap),
    .metrics_amount_picker :deep(.dp__input) {
        width: 100% !important;
        text-align: center;
    }

    .metrics_amount_picker:deep(input::placeholder) {
        padding-left: 10px;
        position: absolute;
        margin-top: 1px;
        font-weight: 500;
    }

    .metrics_amount_picker :deep(.dp__input_icon) {
        left: 90% !important;
    }

}
</style>